import { action, props } from 'ts-action';
import { Cluster } from '../clustering.types';

export const load = action('[Cluster] load', props<{ clusters: Cluster[] }>());

export const selectClusters = action(
  '[Cluster] selectClusters',
  props<{ clusterIds: Set<number> }>(),
);

export const addClusters = action(
  '[Cluster] addClusters',
  props<{ clusters: Cluster[] }>(),
);

export const removeClusters = action(
  '[Cluster] removeClusters',
  props<{ clusterIds: number[] }>(),
);

export const replaceClusters = action(
  '[Cluster] replaceClusters',
  props<{ newClusters: Cluster[]; oldClusters: Cluster[] }>(),
);

export const cleanUp = action('[Cluster] cleanUp');
